<template>

	<transition name="slide-fade">
		<span v-if="loaded=='true'">
			<main  v-if="_locutor.acf.imagen_alternativa!=false" class="col-xs-12 npd">
				<img v-bind:src="_locutor.acf.imagen_alternativa.sizes['1440x446']" alt="" width="100%">
			</main>
			<!-- <main v-else class="col-xs-12 npd" >
				<img v-bind:src="theme_url+'/html/assets/img/holder.jpg'" alt="" width="100%">
			</main> -->
			<section class="col-xs-12 info-locutor" v-if="loaded=='true'">
				<div class="container">
					<div class="row">
						<ul class="breadcrumb">
							<li><a href="#">Inicio</a></li>
							<li><a href="#">Locutores</a></li>
							<li><a href="#" v-html="_locutor.title.rendered"></a></li>
						</ul>
						<h2 v-html="_locutor.title.rendered"></h2>
						<figure class="col-xxs-12 col-xs-3 npd" v-if="_locutor.better_featured_image!=false">
							<img v-bind:src="_locutor.better_featured_image.media_details.sizes['530x626'].source_url" alt="" class="shadow">
						</figure>
						<article class="col-xxs-12 col-xs-9 desarrollo " v-html="_locutor.content.rendered">

						</article>
					</div>
				</div>
			</section>

			<section class="col-xs-12 programa-locutor" v-if="loaded_programas=='true'">
				<div class="container">
					<div class="row" v-for="programa in _programas">
						<div class="col-xs-12 col-sm-3 npd">
							<div class="hidden-xs col-sm-5">

								<img v-if="programa.better_featured_image!=null" v-bind:src="programa.better_featured_image.media_details.sizes['100x100'].source_url" alt="">
								<img v-else v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="">
							</div>
							<div class="col-xs-12 col-sm-7 npd">
								<router-link :to="{ name: 'programa', params: { elprograma: programa.slug }}">
									<p>PROGRAMAS</p>
									<h3 v-html="programa.title.rendered"></h3>
									<p v-if="programa.acf.hasOwnProperty(horarios_texto)">Horario:</p>
									<p v-html="programa.acf.horarios_texto"></p>
								</router-link>
							</div>
						</div>
						<div class="col-xs-12 col-sm-9 player-locutor" v-if="loaded_audiosprograma=='true'">
							<p>ULTIMA REFLEXION</p>
							<br>
							<div class="player__playlist">
								<div class="compartir__player">
									<button><i class="icon share"></i></button>
									<ul>
										<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+programa.link" target="_blank"><i class="fa fa-facebook"></i></a></li>
										<li><a v-bind:href="'https://twitter.com/share?url='+programa.link+'&text='+programa.title.rendered" target="_blank"><i class="fa fa-twitter"></i></a></li>
										<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+programa.link"><i class="fa fa-whatsapp"></i></a></li>
									</ul>
								</div>
								<a href="#" class="fav__player"><i v-bind:programa="programa.id" class="icon star"></i></a>
								<ul class="playlist">

									<li v-for="audio in audiosprograma" v-bind:data-cover="theme_url+'/html/assets/img/imgplay.jpg'" v-bind:data-descripcion="programa.soloexcerpt" class="col-xs-12 npd">
										<a v-if="audio.post_meta_fields.hasOwnProperty('_enclosure_mp3')" v-bind:href="audio.post_meta_fields._enclosure_mp3">
											<span class="titulo" v-html="audio.title.rendered"></span>
											<span class="autor" v-html="audio.author_meta.display_name"></span>
											<span class="fecha" v-html="audio.fechaconformato"></span>
											<span class="duracion">3:22</span>
										</a>
									</li>

								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="col-xs-12 block bgg articulos" v-if="loaded_author=='true'">
				<div class="container">
					<div class="row">
						<h2>OTRAS REFLEXIONES </h2>

						<div class="col-xs-12 col-xs-6 col-md-3 artitem" v-for="post in _postslocutor">
							<router-link :to="{ name: 'post', params: { name:post.slug }}">
								<figure v-if="post.better_featured_image !== null">
									<img v-bind:src="post.better_featured_image.media_details.sizes['536x516'].source_url" alt="">
								</figure>
								<figure v-else-if="post.featured_image_src['full'][0]">
									<img v-bind:src="post.featured_image_src['full'][0]" alt="">
								</figure>
								<figure v-else>
									<img v-bind:src="theme_url+'/html/assets/img/articulo.jpg'" alt="">
								</figure>
								<h4 v-html="_locutor.title.rendered"></h4>
								<h3 v-html="post.title.rendered"></h3>
								<p v-html="post.soloexcerpt"></p>
							</router-link>
						</div>


					</div>
				</div>
			</section>
		</span>

	</transition>
</template>


<script>
export default {
	mounted: function() {
		const vm = this;
		if ( vm.$route.params.locutor ) {
			vm.getLocutor( vm.$route.params.locutor );
		}
	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			_locutor: {},
			_programas: {},
			_postslocutor: {},
			audiosprograma: {},
			loaded: 'false',
			loaded_programas: 'false',
			loaded_author: 'false',
			loaded_audiosprograma:'false',
			pageTitle: '',
			catName: '',
		};
	},
	methods: {
		getPostsAuthor: function( locutorId ) {
			const vm = this;
			vm.loaded_author = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { ellocutor: locutorId, per_page:4,orderby:'rand' }
			} )
			.then( ( res ) => {
				vm._postslocutor = res.data;
				console.log(vm._postslocutor);
				if(res.data.length>0){
					vm.loaded_author = 'true';
				}
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getProgramas: function( progsID ) {
			const vm = this;
			vm.loaded_programas = 'false';
			vm.$http.get( 'wp/v2/programas', {
				params: { include: progsID }
			} )
			.then( ( res ) => {
				vm._programas = res.data;
				vm.loaded_programas = 'true';
				vm.getAudiosPrograma(progsID);
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getAudiosPrograma:function(idPrograma){
			const vm = this;
			vm.loaded_audiosprograma = 'false';
			// console.log(idPrograma);
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: '7', elprograma: idPrograma}
			} )
			.then( ( res ) => {
				// console.log(res.data);
				vm.audiosprograma = res.data;
				if(res.data.length>0){
					vm.loaded_audiosprograma = 'true';
				}

				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
					init_attach();
				});

			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getLocutor: function( locutor ) {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/locutores?slug=' + locutor )
			.then( ( res ) => {
				res = res.data[ 0 ];
				vm.loaded = 'true';
				vm._locutor=res;
				console.log(vm._locutor);
				vm.pageTitle = res.title.rendered;
				vm.$store.commit( 'rtChangeTitle', vm.pageTitle );
				var _tmpprogs='';
				res.acf.programas.forEach(function(item){
					_tmpprogs=_tmpprogs+','+item.ID;
				});
				_tmpprogs=_tmpprogs.substring(1)
				// console.log(_tmpprogs);
				vm.getProgramas(_tmpprogs);
				vm.getPostsAuthor( res.id );
				vm.LaCat=res;
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		}
	}

};
</script>





// WEBPACK FOOTER //
// locutor.vue?c3666dd8